import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import ListForm from '../../../components/ListForm/ListForm.component';
import { commaFormatted, normalizeAmount, formatData } from '../../../utils/transformer.util';
import { UPLOAD_DOCUMENT_FORM_FIELDS } from '../../../constants/Student/student.constant';
import { Button, Input, Checkbox, Pagination, Select } from '../../../components/base/index';

export default class UploadDocument extends Component {
  constructor(props) {
    super(props);
    
    this.onFormChange = this.onFormChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      form: {
        value: {
          
        },
        error: {},
      },
    };
  }

  onFormChange(event) {
    const {
      name,
      value,
      dataset,
      files,
    } = event.target;
    const { inputType = 'text' } = dataset;
    this.setState((prevState) => {
      let formattedValue = value;
      if (inputType === 'number') {
        formattedValue = commaFormatted(value);
      }
      if (inputType === 'file') {
        formattedValue = files[0];
      }

      return {
        form: {
          value: {
            ...prevState.form.value,
            [name]: formattedValue,
          },
          error: {
            ...prevState.form.error,
            [name]: '',
          },
        },
      };
    });
  }

  onSubmit(e) {
    e.preventDefault();
    const { form } = this.state;
    const { handleUploadRapbuFile, history } = this.props;
    handleUploadRapbuFile(form.value, history.goBack);
    // console.log(form.value)
  }

  render() {
    const { form, handleUploadRapbuFile } = this.state;

    return (
      <div className="add-upload-rapbu">
        <h1>Upload RPP</h1>
        <form onSubmit={this.onSubmit}>
          <ListForm
            form={form}
            formFields={UPLOAD_DOCUMENT_FORM_FIELDS}
            onFormChange={this.onFormChange}
            handleUploadFile={this.onFormChange}
          />
          <div className="add-upload-rapbu">
            <Button
              type="submit"
              title="Simpan"
            />
          </div>
        </form>
      </div>
    );
  }
}
UploadDocument.propTypes = {
  handleUploadRapbuFile: PropTypes.func,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};
UploadDocument.defaultProps = {
  handleUploadRapbuFile: noop,
};
